/**
 * @module selectors/meta
 */

/**
 * Returns an element, if any, matching the provided selector
 * and optionally a provided target (recommended)
 * @param {String} selector
 * @param {Document|DocumentFragment|Element} target
 * @returns {?*}
 */
import defaults from './defaults.js'
import one from './one.js'

export default (
  name,
  target = defaults.document
) => {
  return one(`meta[name="${name}"]`, target)?.content
}
